// extracted by mini-css-extract-plugin
module.exports = {"card":"OverviewCard_card__BH1q7","playTime":"OverviewCard_playTime__oe1NJ","hoverBackground":"OverviewCard_hoverBackground__trYL9","hoverText":"OverviewCard_hoverText__82s5H"};